<template>
  <b-modal
    id="level-rewards-modal"
    title="Confirmation"
    hide-footer
  >
    <h4 class="mb-2">
      Are you sure you want to {{ action === 'PROCESS' ? 'approve' : 'reject' }}?
    </h4>

    <b-button
      v-if="action === 'PROCESS'"
      :disabled="loading"
      block
      variant="primary"
      @click="applyActionHandler"
    >
      Yes, approve
    </b-button>
    <b-button
      v-else
      :disabled="loading"
      block
      variant="danger"
      @click="applyActionHandler"
    >
      Yes, reject
    </b-button>
  </b-modal>
</template>

<script>
import { ref } from '@vue/composition-api'
import {
  BModal, BButton,
} from 'bootstrap-vue'
import { errorNotification, successNotification } from '@/utils/toast-notifications'
import axiosIns from '@/libs/axios'

export default {
  components: {
    BModal,
    BButton,
  },
  props: {
    action: {
      type: String,
      default: undefined,
    },
    id: {
      type: String,
      default: undefined,
    },
  },
  setup(props, ctx) {
    const loading = ref(false)
    const applyActionHandler = async () => {
      try {
        loading.value = true
        await axiosIns.patch(`/teams/rewards-action/${props.id}`, {
          action: props.action,
        })
        ctx.root.$bvModal.hide('level-rewards-modal')
        ctx.emit('done')
        successNotification('Success')
      } catch (error) {
        errorNotification('An error occured')
      } finally {
        loading.value = false
      }
    }
    return {
      loading,
      applyActionHandler,
    }
  },
}
</script>
